function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.586 4.586l-1.672-1.672a2 2 0 00-2.828 0L4 16l-.742 4.079a1 1 0 001.163 1.163L8.5 20.5 21.586 7.414a2 2 0 000-2.828zM16.03 6.091l2.379 2.379-9.44 9.439-2.378-2.379 9.439-9.439zM4.863 19.637l.529-2.908.138-.138 2.379 2.379-.138.138-2.908.529zM20.525 6.354L19.47 7.409 17.09 5.03l1.056-1.055a.5.5 0 01.708 0l1.67 1.671a.5.5 0 010 .708z"
});

function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _ref);
}

export default SvgEditIcon;